import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffViewer = () => import('./staff/viewer')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ActivityLogStaffDashboard',
  viewer: 'ActivityLogStaffViewer',
}

const router =
  [
    {
      path: '/st/activity-log',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Registro de actividades',
          }                                  
        },
        {
          path: 'viewer',
          name: VIEWS.viewer,
          component: ViewStaffViewer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Log de registro de actividades',
          }                                  
        },                          
      ]
    },

    {
      path: '/cu/activity-log',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/activity-log',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
